import styled from "@emotion/styled";
import { padding, margin } from "polished";

const marginOverride = {
  margin: 0,
};

export const TitleContainer = styled.div(({ theme }) => ({
  ...marginOverride,
  paddingBottom: theme.spacing[36],
  [theme.breakpoints.phone]: {
    paddingBottom: theme.spacing[20],
  },
}));

export const SubTitle = styled.p(({ theme }) => ({
  ...marginOverride,
  marginTop: theme.spacing[12],
  color: theme.colors.content.secondary,
  ...theme.typography.BodyLargeM,
  textWrap: "pretty",
  [theme.breakpoints.phone]: {
    ...theme.typography.BodySmallM,
  },
}));

export const ErrorBannerWrapper = styled.div(({ theme }) => ({
  marginTop: theme.spacing[28],
}));

export const TakeoverBottomNavWrapper = styled.div(({ theme }) => ({
  ...theme.borders.defaultBorder.top,
  backgroundColor: "white",
  zIndex: theme.zIndex.HEADER,
  position: "absolute",
  width: "100%",
  bottom: 0,
  left: 0,
  [theme.breakpoints.phone]: {
    position: "fixed",
  },
}));

export const TakeoverBottomNavContent = styled.div<{
  stepNavigationMaxWidth?: number;
}>(({ theme, stepNavigationMaxWidth }) => ({
  ...padding(theme.spacing[12], theme.spacing[20]),
  ...margin(0, "auto"),
  display: "flex",
  justifyContent: "space-between",
  maxWidth: stepNavigationMaxWidth ?? 560,
  [theme.breakpoints.phone]: {
    ...padding(theme.spacing[8]),
    justifyContent: "space-between",
    gap: theme.spacing[16],
  },
}));

export const TakeoverContent = styled.div<{ reduceSpacing?: boolean }>(
  ({ theme, reduceSpacing = false }) => ({
    display: "flex",
    flex: 1,
    flexDirection: "column",
    justifyContent: " center",
    margin: "0 auto",
    width: "100%",
    maxWidth: 523,
    ...padding(
      reduceSpacing ? theme.spacing[32] : theme.spacing[64],
      theme.spacing[20],
    ),
    [theme.breakpoints.phone]: {
      ...padding(theme.spacing[16]),
    },
  }),
);

export const PageTemplateWrapper = styled.div<{
  backgroundColor?: string;
}>(({ theme, backgroundColor }) => ({
  height: "calc(100% - 64px)",
  display: "flex",
  flexDirection: "column",
  overflow: "auto",
  ...padding(theme.navHeights.mobile, 0, 0, 0),
  [theme.breakpoints.smallDesktop]: {
    overflowY: "auto",
  },
  ...(backgroundColor && {
    background: backgroundColor,
  }),
}));

export const ProgressBar = styled.div<{ progress: number }>(
  ({ theme, progress }) => ({
    position: "relative",
    zIndex: 999,
    height: 6,
    width: progress ? `${progress * 100}%` : 0,
    backgroundColor: theme.colors.accent.primary.background.default,
    marginTop: 0,
    marginBottom: -6,
    transition: "width 1s",
  }),
);

export const ProgressBarBackground = styled.div(({ theme }) => ({
  position: "relative",
  zIndex: 999,
  height: 6,
  width: "100%",
  backgroundColor: theme.colors.background.tertiary,
  marginTop: 0,
  marginBottom: -6,
}));
